export const SUBSCRIPTION_GET = 'SUBSCRIPTION_GET'
export const SUBSCRIPTION_DELETE = 'SUBSCRIPTION_DELETE'



// WEBPACK FOOTER //
// ./src/store/actions/subscriptions.js